export const buildFolderTree = (folders = []) => {
    const byID = new Map(folders.map((folder) => [folder.id, { ...folder, children: [] }]));
    const roots = [];
    byID.forEach((folder) => {
        const parent = folder.parentFolderID ? byID.get(folder.parentFolderID) : null;
        if (parent) parent.children.push(folder);
        else roots.push(folder);
    });
    const sort = (items) => items.sort((a, b) => a.name.localeCompare(b.name)).map((item) => ({ ...item, children: sort(item.children) }));
    return sort(roots);
};

export const flattenFolderTree = (folders = [], depth = 0) => folders.flatMap((folder) => [
    { ...folder, depth },
    ...flattenFolderTree(folder.children || [], depth + 1),
]);

export const descendantFolderIDs = (folders, folderID) => {
    const childrenByParent = new Map();
    folders.forEach((folder) => {
        const children = childrenByParent.get(folder.parentFolderID) || [];
        children.push(folder.id);
        childrenByParent.set(folder.parentFolderID, children);
    });
    const ids = new Set([folderID]);
    const visit = (id) => (childrenByParent.get(id) || []).forEach((childID) => {
        ids.add(childID);
        visit(childID);
    });
    visit(folderID);
    return ids;
};

export const folderPath = (folders, folderID) => {
    const byID = new Map(folders.map((folder) => [folder.id, folder]));
    const names = [];
    let current = byID.get(folderID);
    while (current) {
        names.unshift(current.name);
        current = byID.get(current.parentFolderID);
    }
    return names.join(' / ');
};
